import { useEffect, useState } from 'react';
import { transferApi, TransferLimits } from '../api/transfer';
import { useAppStore } from '../store/useAppStore';
import { Icon } from '../components/Icon';
import { telegram } from '../lib/telegram';
import { formatTon } from '../lib/format';

export function TransferScreen() {
  const setScreen = useAppStore((s) => s.setScreen);
  const balance = useAppStore((s) => s.balance);
  const setBalance = useAppStore((s) => s.setBalance);
  const showToast = useAppStore((s) => s.showToast);

  const [to, setTo] = useState('');
  const [amount, setAmount] = useState('');
  const [limits, setLimits] = useState<TransferLimits | null>(null);
  const [busy, setBusy] = useState(false);

  const reloadLimits = () => transferApi.limits().then(setLimits).catch(() => undefined);
  useEffect(() => {
    reloadLimits();
  }, []);

  const amountNum = parseFloat(amount) || 0;
  const balanceNum = parseFloat(balance) || 0;
  const fee = amountNum * 0.15;
  const received = Math.max(0, amountNum - fee);
  const remaining = limits ? parseFloat(limits.remaining) : Infinity;
  const canSend =
    !busy && to.trim().replace(/^@/, '').length > 0 && amountNum >= 1 && amountNum <= balanceNum && amountNum <= remaining;

  const send = async () => {
    if (!canSend) {
      if (amountNum > balanceNum) showToast('Недостаточно средств', true);
      else if (amountNum > remaining) showToast('Превышен дневной лимит', true);
      return;
    }
    setBusy(true);
    telegram.haptic('medium');
    try {
      const r = await transferApi.send(to.trim(), String(amountNum));
      setBalance(r.newBalance);
      showToast(`${r.to} получил +${formatTon(r.received)} (комиссия ${formatTon(r.fee)})`);
      telegram.notify('success');
      setAmount('');
      reloadLimits();
    } catch (e: any) {
      const msg = e?.response?.data?.message || 'Ошибка перевода';
      showToast(Array.isArray(msg) ? msg[0] : msg, true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className="page-head">
        <button className="icon-btn" onClick={() => setScreen('profile')} title="Назад">
          <Icon name="back" size={18} />
        </button>
        <span className="title">Перевести другу</span>
      </div>

      <div className="card stack">
        <div className="label-row">
          <span className="label">Кому (@username)</span>
          <span className="muted">баланс {formatTon(balance)}</span>
        </div>
        <div className="field">
          <span className="gem" style={{ fontSize: 14 }}>@</span>
          <input
            value={to}
            onChange={(e) => setTo(e.target.value.replace(/[^A-Za-z0-9_@]/g, ''))}
            placeholder="username получателя"
          />
        </div>

        <div className="label-row">
          <span className="label">Сумма</span>
        </div>
        <div className="field">
          <span className="gem">◆</span>
          <input
            inputMode="decimal"
            value={amount}
            onChange={(e) => setAmount(e.target.value.replace(/[^0-9.]/g, ''))}
            placeholder="0"
          />
          <div className="mini-actions">
            <button onClick={() => setAmount(String(Math.min(balanceNum, remaining)))}>MAX</button>
          </div>
        </div>

        <div className="transfer-info">
          <div>
            <span className="muted">Комиссия 15%</span>
            <b>−{formatTon(fee.toFixed(2))}</b>
          </div>
          <div>
            <span className="muted">Получатель получит</span>
            <b style={{ color: 'var(--green)' }}>{formatTon(received.toFixed(2))}</b>
          </div>
          <div>
            <span className="muted">Лимит сегодня</span>
            <b>{limits ? `${formatTon(remaining)} / ${formatTon(limits.dailyLimit)}` : '…'}</b>
          </div>
        </div>

        <button className="btn" disabled={!canSend} onClick={send}>
          {busy ? <span className="spin" /> : 'Перевести'}
        </button>
        <p className="muted">Получатель должен хоть раз открыть 1Zov. Комиссия удерживается из суммы.</p>
      </div>
    </>
  );
}
